import { ODSTableRowCell } from '@telekom-ods/react-ui-kit';
import { type FC } from 'react';

import { Switch } from '../InputFields';

import Action from './Action';

interface CellValue {
  organizationId: string;
  name?: string;
  description?: string;
  businessUnitId?: string;
  technicalLeadId?: string;
  _id: string;
}

interface ActionItem {
  label: string;
  onClick: (value: CellValue) => void;
  tooltip?: string;
  disabled?: boolean;
}

interface CellProps {
  type?: string;
  value?: string | number | string[] | CellValue;
  props?: Record<string, unknown> & { onChange?: (checked: boolean) => void };
  actions?: ActionItem[];
}

interface CellComponentsProps {
  cell: CellProps;
}

const CellComponents: FC<CellComponentsProps> = ({ cell }) => {
  if (cell.type === 'switch') {
    return (
      <td>
        <Switch
          name={cell.props?.name as string}
          label={cell.props?.label as string}
          onChange={
            cell.props?.onChange ??
            (() => {
              /* empty */
            })
          }
          {...Object.fromEntries(
            Object.entries(cell.props ?? {}).filter(([key]) => key !== 'onChange')
          )}
        />
      </td>
    );
  }
  if (cell.type === 'tags') {
    return (
      <ODSTableRowCell
        type='tags'
        tagsProps={
          Array.isArray(cell.value)
            ? cell.value
                .filter((tag): tag is string => typeof tag === 'string')
                .map((tag, index) => ({ label: tag, key: `tag-${String(index)}` }))
            : []
        }
      />
    );
  }
  if (cell.type === 'progressBar') {
    return (
      <ODSTableRowCell
        type='progress'
        progressBarProps={{
          progress: cell.value as number,
          labelText: typeof cell.value === 'number' ? `${cell.value.toLocaleString()}%` : 'N/A',
        }}
      />
    );
  }

  if (cell.type === 'action') {
    return (
      <td className='ODSTableRowCell ODSTableRowCell--type-label ODSTableRowCell--alignment-left'>
        <Action
          cell={{
            value: cell.value as CellValue,
            actions: cell.actions,
          }}
        />
      </td>
    );
  }
  return <ODSTableRowCell label={(cell.value as string | number) || 'N/A'} />;
};

export default CellComponents;
